import { AccountService } from "../../services/account-service";
import { NotifyService } from "../../services/notify-service";

import * as URI from "urijs";
export class SupportPortalController {
	static $inject = ["$scope", "$q", "$window", "accountService", "notifyService"];

	supportPortalLink: string = "https://rightsline.atlassian.net/servicedesk/customer/portals";


	constructor(private $scope: ng.IScope, private $q: ng.IQService, private $window: ng.IWindowService, private accountService: AccountService, private notifyService: NotifyService) {
	}

	SupportPortal() {
		this.notifyService.startProgress();
		//Check if jira account exists
		this.accountService.checkIfJiraAccountExists().then((result) => {
			//if account exists, navigate to support portal
			if (result.hasAccount) {
				window.location.href = this.supportPortalLink;
			}
			else {
			//else create a jira account, delay for a little bit by waiting for user to click OK, then send reset password email for the jira account
				this.accountService.createJiraAccount().then((result) => {
					if (result.accountCreated) {
						alert("Please check your email to complete Help Center access setup.");
						this.accountService.sendJiraResetPasswordEmail();
					}
				});
			}
		}).finally(() => {
			this.notifyService.endProgress();
		});
	}
}